// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const corphish: PokeData = {
  "id": 341,
  "name": "corphish",
  "height": 6,
  "weight": 115,
  "base_experience": 62,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "vice-grip",
    "guillotine",
    "swords-dance",
    "leer",
    "water-gun",
    "bubble-beam",
    "harden",
    "bubble",
    "crabhammer",
    "protect",
    "crunch",
    "taunt",
    "knock-off",
    "endeavor",
    "night-slash",
    "double-hit",
    "razor-shell"
  ],
  "moves": [
    "leer",
    "bubble-beam",
    "bubble",
    "protect",
    "crunch",
    "night-slash",
    "liquidation",
    "water-spout",
    "rain-dance",
    "aqua-tail",
    "hydro-pump",
    "life-dew",
    "brine"
  ],
  "evolution_chain": {
    "id": 174,
    "item": null,
    "species": [
      {
        "name": "corphish",
        "order": 369,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "crawdaunt",
        "order": 370,
        "types": [
          PokeType.WATER,
          PokeType.DARK
        ],
        "evolves_from_species_id": 341,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 46.5,
    "speed": 35,
    "ability_power": 80
  },
  "stat_changes": [],
  "catch_rate": 205,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
